// extracted by mini-css-extract-plugin
export default {"link":"SubsectionWithLink__link-oNowE"};